import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

import {
  PATH_RESOLVABLE_MISSION_TYPE_DEFAULT,
  PATH_RESOLVABLE_MISSION_TYPES,
} from '../../app/constants/paths.constant';
import { Breadcrumbs } from '../../components/Breadcrumbs';
import { Loading } from '../../components/Loading';
import { useIdParam } from '../../utils/use-id-param.util';
import { Page } from '../../contexts/NavigationContext/enums/page.enum';
import { useNavigationContext } from '../../contexts/NavigationContext/hooks/useNavigationContext.hook';
import { useBuildPath } from '../../hooks/useBuildPath.hook';
import { buildDocumentTitle } from '../../utils/document-title.util';
import { PageTitle } from '../../components/PageTitle';

import { ResolvableMissionTypeTabs } from './Tabs';
import { useFindOneResolvableMissionTypeQuery } from './hooks/useFindOneResolvableMissionTypeQuery.hook';

export const ResolvableMissionTypePage = () => {
  const { setPage } = useNavigationContext();
  const id = useIdParam();

  const path = useBuildPath(PATH_RESOLVABLE_MISSION_TYPE_DEFAULT, {
    id,
  });

  const { data, isSuccess } = useFindOneResolvableMissionTypeQuery(id);

  useEffect(() => {
    setPage(Page.ResolvableMissionTypes);
  }, [setPage]);

  const beforeTitleContent = (
    <>
      <Helmet>
        <title>
          {buildDocumentTitle(
            'Fiche Type de Mission',
            data?.findOneResolvableMissionType.code,
          )}
        </title>
      </Helmet>
      <Breadcrumbs
        paths={[
          {
            to: PATH_RESOLVABLE_MISSION_TYPES,
            label: 'types de mission',
            key: 'missionTypes',
          },
          {
            to: path,
            label: 'fiche',
            key: 'missionType',
          },
        ]}
      />
    </>
  );

  const titleContent = <PageTitle title="Fiche Type de Mission" />;

  if (isSuccess) {
    const resolvableMissionType = data.findOneResolvableMissionType;

    return (
      <>
        {beforeTitleContent}
        <PageTitle
          code={resolvableMissionType.code}
          title={resolvableMissionType.label}
        />
        <ResolvableMissionTypeTabs
          resolvableMissionType={resolvableMissionType}
        />
      </>
    );
  }

  return (
    <>
      <Loading />
      {beforeTitleContent}
      {titleContent}
    </>
  );
};
